import { apiFetch } from 'zn-common'

/**
 * 请求登录
 * @param params
 */
export const modifyPwd = async (params = {}): Promise<any> => apiFetch({ url: 'memberManage/modifyPwd.do', method: 'post' }, { data: params })

export const getAgentInfo = async (params = {}): Promise<any> => apiFetch({ url: 'agent/agentDetail.do' }, { data: params })
